import React from "react";
import type { IOrganizationPageTab } from "../../../SharedPages/OrganizationPage/OrganizationPage";
import { OrganizationPage } from "../../../SharedPages/OrganizationPage/OrganizationPage";
import { useAuthContext } from "../../../../components/Auth";
import { useAuthenticatedUser } from "../../../../hooks/useAuthenticatedUser";
import { CompanyInfo } from "../../../SharedPages/OrganizationPage/CompanyInfo/CompanyInfo";
import { ManageUsersList } from "../../../SharedPages/OrganizationPage/UsersList/UsersList";
import { ManageRegions } from "../../../SharedPages/OrganizationPage/ManageRegions";
import { useIsActylisStorefront } from "../../../../util/util";

export const SellerAdminOrganization = () => {
  const user = useAuthenticatedUser();
  const isActylisStorefront = useIsActylisStorefront();
  const { roleIsSellerAdmin } = useAuthContext();

  const tabs: IOrganizationPageTab[] = React.useMemo(() => {
    // Only seller admin has "HR rights" to CRUD users
    if (roleIsSellerAdmin) {
      return [
        {
          label: "Company Info",
          component: <CompanyInfo user={user} />,
        },
        {
          label: "Users",
          component: <ManageUsersList user={user} />,
        },
        ...(isActylisStorefront
          ? []
          : [
              {
                label: "Regions",
                component: <ManageRegions />,
              },
            ]),
      ];
    } else {
      return [
        {
          label: "Company Info",
          component: <CompanyInfo user={user} />,
        },
      ];
    }
  }, [isActylisStorefront, roleIsSellerAdmin, user]);

  return <OrganizationPage tabs={tabs} />;
};
